import ServiceCategoryPage from "../components/ServiceCategoryPage";
import solarTechnicianService from "../data/services/solarTechnicianService";

function SolarTechnician() {
  return <ServiceCategoryPage service={solarTechnicianService} />;
}

export default SolarTechnician;